import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 6.143a.64.64 0 0 0-.643-.643H2.643A.64.64 0 0 0 2 6.143c0 .356.287.643.643.643h10.714A.64.64 0 0 0 14 6.143m0 3.428a.64.64 0 0 0-.643-.642H2.643A.64.64 0 0 0 2 9.57c0 .357.287.643.643.643h10.714A.64.64 0 0 0 14 9.571"
    }, null, -1)
  ]))]))
}
export default { render: render }